
const digest = 'b3a837b2f68e72fd78c8a70b9d5c21dcdf59d6790fa5f1b9a691fa6c4d18af00';
const classes = {"wrapper":"_wrapper_1xr5k_1"};
const css = `._wrapper_1xr5k_1 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  font-weight: 500;
  color: #d81616;
  margin: 10px 0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  